import { useSiteContent } from '@/context/SiteContentContext';

export default function Team() {
  const { content } = useSiteContent();
  const t = content.team;

  return (
    <section id="team" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">Our People</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Our <span className="text-teal-600">Team</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">{t.para1}</p>
            <p className="text-gray-600 leading-relaxed mb-6">{t.para2}</p>
            <p className="text-gray-600 leading-relaxed mb-6">{t.para3}</p>
            <p className="text-gray-600 leading-relaxed mb-8">{t.para4}</p>
            <div className="flex flex-wrap gap-2">
              {['ICT','Geomatics','Geoinformatics','Research','Project Management','M&E','Statistics','Remote Sensing','GIS Analysis','Cloud Services'].map((tag) => (
                <span key={tag} className="bg-teal-50 text-teal-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-teal-100">{tag}</span>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="group rounded-2xl overflow-hidden border border-gray-100 hover:border-teal-200 transition-all bg-white">
              <div className="relative h-64 bg-gradient-to-br from-teal-50 to-gray-100">
                <img src={t.photo1} alt="Team member" className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              </div>
            </div>
            <div className="col-span-2 group rounded-2xl overflow-hidden border border-gray-100 hover:border-teal-200 transition-all bg-white">
              <div className="relative w-full bg-gray-50" style={{ aspectRatio: '16/7' }}>
                <img src={t.photo2} alt="Our full team" className="w-full h-full object-contain object-center" />
              </div>
            </div>
            <div className="col-span-2 bg-teal-600 rounded-2xl p-6 flex items-center justify-around">
              {[{ value: '100+', label: 'Man-Years Experience' }, { value: 'π', label: 'Multi-Disciplinary Staff' }, { value: '10+', label: 'Years Building Teams' }].map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-3xl font-black text-white">{s.value}</div>
                  <div className="text-teal-200 text-xs mt-1 font-medium">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
